import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AuthGuard from "../components/security/AuthGuard";
import UserLayout from "../layouts/user";
import AuthLayout from "../layouts/auth";
import BankAccountReport from "../views/user/reports/components/BankAccountReport";
import CashAccountReport from "../views/user/reports/components/CashAccountReport";
import ExpenseReport from "../views/user/reports/components/ExpenseReport";
import IncomeReport from "../views/user/reports/components/IncomeReport";
import TransferReport from "../views/user/reports/components/TransferReport";
import RecitaReport from "../views/user/reports/components/RecitaReport";
import DespeseaReport from "../views/user/reports/components/DespeseaPdfReport";
import BalanceReport from "../views/user/reports/components/BalancoReport";

import QuaterlyExpenseReport from "../views/user/reportsQuaterly/components/ExpenseReport";
import QuaterlyIncomeReport from "../views/user/reportsQuaterly/components/RecitaReport";
import QuaterlyBalanceReport from "../views/user/reportsQuaterly/components/BalancoReport";



import AccountSpecificReport from "../views/user/reports/components/AccountSpecificReport";


const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="user/*" element={  <AuthGuard> <UserLayout />  </AuthGuard>} />
      <Route path="/bank-report" element={<AuthGuard> <BankAccountReport /> </AuthGuard>} />
      <Route path="/cash-report" element={<AuthGuard> <CashAccountReport /> </AuthGuard>} />
      <Route path="/reports/income-report" element={<AuthGuard> <IncomeReport /> </AuthGuard>} />

      <Route path="/reports/transfer-report" element={<AuthGuard> <TransferReport /> </AuthGuard>} />
      <Route path="/reports/recita-report" element={<AuthGuard> <RecitaReport /> </AuthGuard>} />
      <Route path="/reports/expense-report" element={<AuthGuard> <ExpenseReport /> </AuthGuard>} />
      <Route path="/reports/account-specific" element={<AuthGuard> <AccountSpecificReport /> </AuthGuard>} />
      <Route path="/reports/despesea-report" element={<AuthGuard> <DespeseaReport /> </AuthGuard>} />
      <Route path="/reports/balance-report" element={<AuthGuard> <BalanceReport /> </AuthGuard>} />

      <Route path="/quaterly-reports/recita-report" element={<AuthGuard> <QuaterlyIncomeReport /> </AuthGuard>} />
      <Route path="/quaterly-reports/despesa-report" element={<AuthGuard> <QuaterlyExpenseReport /> </AuthGuard>} />
      <Route path="/quaterly-reports/balance-report" element={<AuthGuard> <QuaterlyBalanceReport /> </AuthGuard>} />



      <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;
